import * as signalR from '@microsoft/signalr';
import api, { handleApiError } from './client';

export const notificationService = {
  /**
   * Retrieves active notifications for current admin
   */
  getNotifications: async () => {
    try {
      const response = await api.get('/api/notifications');
      return response.data;
    } catch (error) {
      console.error('Get notifications error:', error);
      return handleApiError(error, 'Errore nel caricamento delle notifiche');
    }
  },

  /**
   * Deletes a specific notification by ID
   */
  deleteNotification: async (id) => {
    try {
      const response = await api.delete(`/api/notifications/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete notification error:', error);
      return handleApiError(error, "Errore durante l'eliminazione della notifica");
    }
  },

  /**
   * Deletes all notifications for current admin
   */
  deleteAllNotifications: async () => {
    try {
      const response = await api.delete('/api/notifications');
      return response.data;
    } catch (error) {
      console.error('Delete all notifications error:', error);
      return handleApiError(error, "Errore durante l'eliminazione di tutte le notifiche");
    }
  },

  /**
   * Initializes and starts SignalR real-time connection for admin notifications
   * @param {Function} onNotificationReceived Callback invoked when a notification arrives
   * @returns {signalR.HubConnection | null}
   */
  startSignalRConnection: (onNotificationReceived) => {
    const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
    if (!token) return null;

    const baseUrl = process.env.REACT_APP_API_URL || '';
    const hubUrl = `${baseUrl}/hubs/notifications`;

    const hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
      .configureLogging(signalR.LogLevel.None)
      .build();

    hubConnection.on('ReceiveNotification', (notification) => {
      if (typeof onNotificationReceived === 'function') {
        onNotificationReceived(notification);
      }
    });

    hubConnection.start().catch((err) => {
      console.warn('SignalR notification hub connection error:', err);
    });

    return hubConnection;
  },
};
